import React from "react";
import BreadcrumbArea from "../../components/BreadcrumbArea/BreadcrumbArea";
import Layout from "../../layouts/Layout";

import Projects from "./Projects";
import ClientsTalk from "./ClientsTalk";
import ProjectDetailsArea from "./ProjectDetailsArea";

function ProjectSection() {
  return (
    <Layout header={1} footer={1} className="" mainClassName="">
      <BreadcrumbArea
        title={"Project Details"}
        subtitle={"Projects"}
        className={"breadcrumb-area-two pt-175"}
        showShape={false}
      />
      <ProjectDetailsArea />
      <Projects />
      <ClientsTalk />
    </Layout>
  );
}

export default ProjectSection;
